export const SET_AVAILABLE_ASSETS = "SET_AVAILABLE_ASSETS";
export const SHOW_ERROR_MESSAGE = "SHOW_ERROR_MESSAGE";
export const SHOW_SUCCESS_MESSAGE = "SHOW_SUCCESS_MESSAGE";
export const HIDE_TOAST_MESSAGE = "HIDE_TOAST_MESSAGE";